module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAADBQTFRFAAAAgYGIgIOHgYGIgYGIgYGHgYGJf4KGfoKFf4KGfoKFf4GGfoKFf4GGfYKFfoGFoEwvxgAAAA90Uk5TAEdISUt9f7W2t+Lj5Pv8MVnIZQAAAF1JREFUKM9jYACB2P9A8IwBAe6DBP7CeFJADogGUovAAusRAr/AAkDefpCW32AmRMAHJLAZSQAGaCtQD7L2Oz4BatgyH2wkqi0/aO85UgVAEQUFkIjSQggsZCACAAC3bnw/Q+a7DwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/e1_order@2x.png
// module id = 9FRe
// module chunks = 1